export const retriveRegionSucursalOptions = (
  queryRegion,
  querySucursal,
  regionesParam,
  sucursales,
  casasCentrales,
  isLoading,
  filterPerfil = false,
  currentUser = false,
  // cuando es true agrega el numero de cc al label de las sucursales
  ccToLab = false
) => {
  let disableRegionSucursal = false;
  if (isLoading) {
    return { selectedRegion: "", selectedSucursal: "", regionesOptions: [], casasAndSucusOptions: [], disableRegionSucursal };
  }
  // Join casas centrales y sucursales
  let casasAndSucus = casasCentrales.concat(sucursales);
  let regiones = regionesParam;

  let selectedSucursal = parseInt(querySucursal, 10);

  if (filterPerfil && currentUser) {
    const userCasasAndSucus = currentUser.casasCentralesAsignadas.concat(currentUser.sucursalesAsignadas);
    const casasSucusId = userCasasAndSucus.map((item) => item.itemId);
    const regionesId = userCasasAndSucus.map((item) => item.region2);
    casasAndSucus = casasAndSucus.filter((item) => casasSucusId.includes(item.itemId));
    regiones = regiones.filter((item) => regionesId.includes(item.itemId));
    if (casasAndSucus.length === 1) {
      selectedSucursal = casasAndSucus[0].itemId;
      disableRegionSucursal = true;
    }
  }

  // Region seleccionada, si hay una sucursal seleccionada, pero no una region,
  // pongo como seleccionada la region de esa sucursal
  const selectedRegion = selectedSucursal && !queryRegion ? casasAndSucus.find((item) => selectedSucursal === item.itemId).region2 : parseInt(queryRegion, 10);

  // Transformo el objeto regiones a atributos de options
  const regionesOptions = regiones
    .map((region) => {
      return { label: region.title, value: region.itemId };
    })
    .sort((a, b) => (a.label > b.label ? 1 : -1));

  // Uno las sucursales y las casas centrales y les transformo los atributos a options

  const casasAndSucusOptions = casasAndSucus
    // Si hay seleccionada una region, filtro a solo las sucursales de esa region
    .filter((casaCentral) => !queryRegion || casaCentral.region2 === selectedRegion)
    .map((item) => {
      // se saca el cc de las sucursales q no son de CASA CENTRAL
      return ccToLab
        ? {
            label: `${item.Region2 && item.Region2.title === "CASA CENTRAL" ? item.cc : ""}  ${item.titulo || item.title}`,
            value: item.itemId,
            estado: item.estado,
          }
        : { label: item.title || item.titulo, value: item.itemId, estado: item.estado };
    })
    .sort((a, b) => (a.label > b.label ? 1 : -1));

  return { selectedRegion, selectedSucursal, regionesOptions, casasAndSucusOptions, disableRegionSucursal };
};
